import "@hotwired/turbo-rails"
import "./controllers"
import "basecoat-css/basecoat"

declare global {
  interface Window {
    basecoat?: {
      initAll: (options?: { force?: boolean }) => void
    }
  }
}

function initBasecoat(force = false) {
  window.basecoat?.initAll?.(force ? { force: true } : undefined)
}

document.addEventListener("turbo:load", () => initBasecoat())
document.addEventListener("turbo:render", () => initBasecoat(true))

document.addEventListener("DOMContentLoaded", () => initBasecoat())
